<template>
    <div class="cms">
        <div v-if="the_page">
            <slot></slot>
            <div v-if="hasPermission(['manage:Content'])">
                <v-btn fab absolute right center class="cms-edit-btn" :to="{name : 'CMSEditor', 'params' : {page_id : the_page.id} }">
                    <v-icon small class="mr-2">fas fa-pencil-alt</v-icon>
                    {{the_page.status}}
                </v-btn>
            </div>
            <div v-for="(block, key) in the_page.blocks" :key="key" :class="blockClasses(block, 'my-7')">
                <div v-if="showBlock(block)" :is="block.type" :content-data="block"></div>
            </div>
        </div>
        <v-progress-linear v-else-if="loading" indeterminate color="primary"></v-progress-linear>
        <!-- <div v-else-if="!user.demo_mode">Page not found... please create a page with the slug <em>"{{slug}}" for this tenant!</em></div> -->
    </div>
</template>
<script>
import index from './index.vue';
import QuilityAPI from '@/store/API/QuilityAPI.js'

export default {
    extends: index,
    data : function(){
        return {
            loading: true
        }
    },
    methods: {
        loadPage: function(slug) {
            var g = this
            g.loading = true
            QuilityAPI.getPageWithSlug(slug, this.current_tenant.ID)
                .then(function() {
                    g.loading = false
                    if (!g.is_visible && g.noTemplate !== true) {
                        g.$router.push("/404")
                    }
                })
                .catch(function(err) {
                    g.loaded = true;
                    g.loading = false
                    if (!g.is_visible && g.noTemplate !== true) {
                        g.$router.push("/404")
                    }
                });
        }
    }
}

</script>
